module.exports = __webpack_public_path__ + "static/media/alberteinstein_natal.1d2dcb39.jpg";